export function throttleTimeout(throttle: number, fn: () => void): void {
	if (throttle > 0) {
		setTimeout(fn, throttle);
	} else {
		fn();
	}
}
